import React from "react";
import { injectIntl } from "react-intl";
import DataGrid, { DataGridItem } from "components/data-grid";
import withStyles from "components/with-styles";
import { DeploymentAutocompleteSelect } from "components/autocomplete";
import { CustomDatepicker } from "components/form/form-datepicker";
import styles from "./styles.css.js";
import { SearchClearButton } from "components/buttons";
import PropTypes from "prop-types";

const SearchForm = ({ classes, intl, onChange, searchState, onClear }) => (
  <DataGrid>
    <DataGridItem big>
      <DeploymentAutocompleteSelect
        id="searchAutocomplete"
        name="deploymentId"
        placeholder={intl.formatMessage({ id: "app.page.deployment.list.search" })}
        label={intl.formatMessage({ id: "app.page.deployment.list.search.label" })}
        onChange={onChange}
        value={searchState.deploymentId}
      />
    </DataGridItem>
    <DataGridItem small className={classes.flexContainer}>
      <div className={classes.flexDate}>
        <CustomDatepicker
          isStart
          withTime={false}
          className={classes.fullWidth}
          value={searchState.startDate}
          label={intl.formatMessage({ id: "common.since" })}
          id="startDate"
          name="startDate"
          onChange={onChange("startDate")}
        />
      </div>
    </DataGridItem>
    <DataGridItem small className={classes.flexContainer}>
      <div className={classes.flexDate}>
        <CustomDatepicker
          isEnd
          withTime={false}
          className={classes.fullWidth}
          value={searchState.endDate}
          label={intl.formatMessage({ id: "common.until" })}
          id="endDate"
          name="endDate"
          onChange={onChange("endDate")}
        />
      </div>
    </DataGridItem>
    <DataGridItem className={classes.flexContainer}>
      <SearchClearButton className={classes.flexButton} onClick={onClear} />
    </DataGridItem>
  </DataGrid>
);

SearchForm.propTypes = {
  /**
   * Estado del formulario de búsqueda
   */
  searchState: PropTypes.object,
  /**
   * Callback que se dispara con el borrado del formulario
   */
  onClear: PropTypes.func,
  /**
   * Callback que se dispara con el cambio del input
   */
  onChange: PropTypes.func,
};

export default injectIntl(withStyles(styles)(SearchForm));
